import homeowner1_1 from './../images/tenants-landlord-img/homeowner1-1.png';
import homeowner1_2 from './../images/tenants-landlord-img/homeowner1-2.png';
import signature from './../images/tenants-landlord-img/homeowner5-.png';
import homeowner6_1 from './../images/tenants-landlord-img/homeowner6-1.png';
import homeowner6_2 from './../images/tenants-landlord-img/homeowner6-2.png';
import homeowner_screening_1 from './../images/tenants-landlord-img/homeowner-screening-1.png';
import homeowner_screening_2 from './../images/tenants-landlord-img/homeowner-screening-2.png';
import homeowner2_1 from './../images/tenants-landlord-img/homeowner2-1.png';


const LandlordInfo = [
    {
        heading: 'Add Property',
        text: 'This is your time to shine. Tell us about your property. Does it have an awesome view? Is it close to a farmers market? Don’t be shy. Set your guide price, select amenities and add a brief description. Also, remember to add quality photos!',
        img: [homeowner1_1, homeowner1_2]
    },
    {
        heading: 'eSign Contract',
        text: 'Rentberry eliminates the hassle of coordinating schedules to get a rental lease agreement signed. Simply upload your document to Rentberry. Tenants access a secure version of the lease, and you receive an electronically signed and legally binding document in seconds.',
        img: signature
    },
    {
        heading: 'Schedule Tours Online',
        text: 'Tours help you choose the best tenant among your prospects. Let us take care of tour scheduling for your rental showings. We’ll help you synchronize the calendars with your applicants and show your property when it’s convenient for both of you.',
        img: [homeowner6_1, homeowner6_2]
    }, 
    {
        heading:'Screen Tenants',
        text: 'Rentberry makes finding a perfect tenant simple. We investigate all available records from both state and federal databases. You get an instant screening report along with the credit score and history, thorough background and criminal check.',
        img: [homeowner_screening_1, homeowner_screening_2]
    }, 
    {
        heading: 'Share Listing',
        text: 'You can get even more quality applicants with Rentberry! Reach millions of renters – market your listing on our partners’ websites with just one click! It’s no surprise Rentberry landlords rent their properties 30-40% faster. Share your vacancy and get the leads within 24 hours!',
        img: homeowner2_1
    }
]


export default  LandlordInfo;